<template>
  <div class="modal fade" id="AddCategorieClientModal" tabindex="-1" role="dialog" ref="addCategorieClientModalRef" aria-labelledby="tooltipmodal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{ title }}</h4>
                <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
          <Form ref="categorieClientForm" @submit="addCategorieClient" :validation-schema="categorieClientSchema">
            <div class="row">
            <div class="col-md-6 mb-3">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10" >
                  Code <span class="text-danger">*</span>
                </label>
                <Field name="code" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le code"/>
                <ErrorMessage name="code" class="text-danger"/>
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Libelle <span class="text-danger">*</span>
                </label>
                <Field name="libelle" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le libelle"/>
                <ErrorMessage name="libelle" class="text-danger"/>
              </div>
            </div>
            <button
              class="btn btn-primary"
              type="submit"
            >
            {{ btntext }}
            </button>
      </div>
        </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import { hideModal } from '@/utils/utils';
import { CategorieClient } from '@/models/CategorieClient';
import { error, success } from '@/utils/utils';
import { useRouter } from 'vue-router';

export default defineComponent({
    name: "AddCategorieClientModal",
    components: {
    Form,
    Field,
    ErrorMessage,
  },
  props: {
    item: {
      type: Number,
      default: 0,
    }
  },
  setup(props, { emit }){
    const categorieClientSchema = Yup.object().shape({
      code: Yup.string().required('Le code est obligatoire'),
      libelle: Yup.string().required('Le libelle est obligatoire'),
    });

    const categorieClientForm = ref<CategorieClient | null>(null);
    const addCategorieClientModalRef = ref<null | HTMLElement>(null);
    const router = useRouter();
    const isUPDATE = ref(false);
    const title = ref("Ajouter une catégorie client");
    const btntext = ref('Ajouter');

    watch(() => props.item, (newValue) => {
      getCategorieClient(newValue);
      isUPDATE.value = true;
      btnTitle();
    });

    const btnTitle = async () => {
      if (isUPDATE.value) {
         title.value = "Modifier la catégorie client";
         btntext.value = "Modifier";
      } else {
         title.value = "Ajouter une catégorie client";
         btntext.value = "Ajouter";
      }
    }

    const getCategorieClient = async (id: number) => {
      return ApiService.get("/categorieclient/"+id)
      .then(({ data }) => {
        const donnees = data.data;
        for (const key in donnees) {
          categorieClientForm.value?.setFieldValue(key, 
          (typeof donnees[key] === 'object' && donnees[key] !== null)? donnees[key].id :donnees[key]
          );
        }
        emit('openmodal', addCategorieClientModalRef.value);
      })
      .catch(({ response }) => {
        error(response.data.message);
      });
    }

    const addCategorieClient = async (values: any, categorieClientForm) => {
      values = values as CategorieClient;
      if(isUPDATE.value){
        ApiService.put("/categorieclient/"+values.id, values)
        .then(({ data }) => {
            if(data.code == 200) { 
              success(data.message);
              categorieClientForm.resetForm();
              hideModal(addCategorieClientModalRef.value);
              isUPDATE.value = false;
              btnTitle();
              emit('close');
            }
        })
        .catch(({ response }) => {
            error(response.data.message);
        });
      } else {
        ApiService.post("/categorieclient", values)
        .then(({ data }) => {
            if(data.code == 201) { 
              success(data.message);
              categorieClientForm.resetForm();
              hideModal(addCategorieClientModalRef.value);
              emit('close');
            }
        })
        .catch(({ response }) => {
            error(response.data.message);
        });
      }
    };

    const resetValue = () => {
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
      isUPDATE.value = false;
      formFields.forEach(field => {
        field.value = '';
      });
      btnTitle();
    };

    return { 
      categorieClientSchema,
      addCategorieClientModalRef,
      addCategorieClient,
      categorieClientForm,
      title,
      btntext,
      resetValue,
    };
  },
});
</script>